/* returns fields which have fieldKey as a dependency */
export default function getDependents(fieldsList: TField[], fieldKey: string) {
    const dependents: string[] = [];

    function findDependents(key: string) {
        fieldsList.forEach((field) => {
            if (field.dependsOn && field.dependsOn.find((r) => r.includes(key))) {
                dependents.push(field.key);

                // Recursive call for nested dependents
                findDependents(field.key);
            }
        });
    }

    findDependents(fieldKey);
    return dependents;
}

type TField = {
    key: string;
    dependsOn?: string[];
};

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('getDependents', async () => {
        it('lists dependent fields', () => {
            expect(
                getDependents(
                    [
                        { key: 'stack', dependsOn: [] },
                        { key: 'skill', dependsOn: ['stack'] },
                        { key: 'subSkill', dependsOn: ['skill'] },
                    ],
                    'stack',
                ),
            ).toStrictEqual(['skill', 'subSkill']);
        });
    });
}

// #endregion
